export default class ValueFormatter {

    static MoneyFormat(value) {
        return value > 0 ? value.toFixed(2).toLocaleString('en-US') : null;
    }

    static PercentageFormat(value) {
        return value.toFixed(1) + " %";
    }

    static decimal(value, fallbackValue) {
        if (value.toLowerCase() != value.toUpperCase())
            value = fallbackValue.toString();

        value = value.replace(',', '.');

        return value;
    }
}